import React from 'react'
import { useUserNames } from '../../contexts/userNames'

const NameTag = ({ userToken, onUpdate, nickname='', ...props }) => {
  const { setNickname, getNickname } = useUserNames()
  const cachedNickname = getNickname(userToken)

  const onClick = () => {
    const newNickname = prompt('Enter new nickname', nickname || '')
    if (!newNickname) {
      return
    }
    setNickname(userToken, newNickname)
    onUpdate(userToken, newNickname)
  }

  return (
    <span onClick={onClick} {...props}>
      {nickname || cachedNickname}
    </span>
  )
}

export default NameTag
